import Navbar from "@/components/feature/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import FilmInfo from "./components/FilmInfo";
import PlotTimeline from "./components/PlotTimeline";
import Cast from "./components/Cast";
import Commentary from "./components/Commentary";
import Reviews from "./components/Reviews";
import Clips from "./components/Clips";
import Bloopers from "./components/Bloopers";
import EasterEggs from "./components/EasterEggs";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body">
      <Navbar />
      <main>
        <Hero />
        <About />
        <FilmInfo />
        <PlotTimeline />
        <Cast />
        <Commentary />
        <Reviews />
        <Clips />
        <Bloopers />
        <EasterEggs />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}